import { render } from "./parts.web.vue?vue&type=template&id=a8bfb58a&ts=true"
import script from "./parts.web.ts?vue&type=script&scoped=true&lang=ts"
export * from "./parts.web.ts?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__